// @core/api/endpoints/affiliate/create_postback.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePostbackRequest,
  PostbackResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Create postback for offer
 * Creates a new postback with the provided data. Returns the created resource.
 */
export async function CreatePostback(
  offer_id: string,
  data: CreatePostbackRequest,
  options?: RequestOptions
): Promise<PostbackResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/offers/:offer_id/postbacks`;
  requestPath = requestPath.replace(':offer_id', encodeURIComponent(offer_id));
  const requestOptions = options;
  return client.post<PostbackResponse>(requestPath, data, requestOptions);
}
